export default __webpack_public_path__ + "static/media/Role of research in policy making.1651baf1.pdf";